<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="productIntroductionTemplate.pkid ? '编辑' : '新建'"
      class="edit"
      width="850px"
      top="5vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="productIntroductionTemplate"
        :rules="ruleValidate"
        class="form"
        label-width="80px">
      <div class="vm-separate">
        <el-form-item label="产品名" prop="templateName">
          <el-input v-model="productIntroductionTemplate.templateName" placeholder="请输入"/>
        </el-form-item>
        <div/>
      </div>
    </el-form>
    <div>
      <div slot="toolbar">
        <el-button type="primary" style="margin-bottom: 3%" @click="$refs.editpage.open(0)">新建</el-button>
      </div>
      <el-table
          :data="tableData"
          border
          style="width: 100%">
        <el-table-column prop="groupIndex" align="center" label="显示顺序"/>
        <el-table-column prop="groupName" align="center" label="分组名称"/>
        <el-table-column prop="groupType" align="center" label="分组类型">
          <template slot-scope="scope">
            <span v-if="scope.row.groupType===10" style="color: #2D8CF0">
              键值对类型
            </span>
            <span v-if="scope.row.groupType===20" style="color: #2D8CF0">
              表格类型
            </span>
          </template>
        </el-table-column>
        <el-table-column
            label="操作"
            align="center"
            class-name="vm-table_operate"
            width="120px">
          <template slot-scope="scope">
            <el-button type="primary" @click.native.prevent="$refs.editpage.open(scope.row,scope.$index)">编辑</el-button>
            <el-button type="danger" @click="oneDelete(scope.$index,scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <product-introduction-template-group-edit ref="editpage" @save-success="getList"/>
    <span slot="footer">
      <el-button @click="dialogVisible=false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
    </span>
  </el-dialog>
</template>
<script>

  import ProductIntroductionTemplateGroupEdit
    from "@/views/information/ProductIntroductionTemplate/productIntroductionTemplateGroupEdit";
  export default {
    name:"ProductIntroductionTemplateEdit",
    components: {ProductIntroductionTemplateGroupEdit},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        tableData: [],
        deleteIds: [],
        paramsIds: [],
        idList:"",
        allDelete:false,
        productIntroductionTemplate: {
          pkid: 0,
          templateName: "",
          isDeleted: false,
          productIntroductionTemplateGroupVOS: [],
        },
        ruleValidate: {
          templateName: {required: true, message: "不能为空", trigger: "blur"},
        },
      };
    },
    methods: {
      open(id) {
        this.dialogVisible = true;
        this.productIntroductionTemplate.pkid = id;
        if (id > 0) {
          this.getData();
        }
      },
      getData() {
        this.$http
          .get("basic", `productIntroductionTemplates/${this.productIntroductionTemplate.pkid}`)
          .then(resp => {
            this.productIntroductionTemplate = resp;
            this.tableData = this.productIntroductionTemplate.productIntroductionTemplateGroupVOS;
          });
      },
      getList(row,index,list) {
        this.paramsIds = list;
        if(index >= 0) {
          this.tableData[index].pkid = row.pkid;
          this.tableData[index].groupIndex = index+1;
          this.tableData[index].groupName = row.groupName;
          this.tableData[index].groupType = row.groupType;
          this.tableData[index].productIntroductionTemplateParams = row.productIntroductionTemplateParams;
        }else{
          this.tableData.push({pkid:0, groupIndex:this.tableData.length+1,groupName: row.groupName, groupType: row.groupType, productIntroductionTemplateParams:row.productIntroductionTemplateParams});
        }
      },
      //页面删除
      oneDelete(index,row) {
        this.tableData.splice(index,1);
        if(row.pkid) {
          this.deleteIds.push(row.pkid);
        }
        //使tableData重新排序
        this.tableData.forEach((item, index) => {
          item.groupIndex = index+1;
        });
      },
      //数据库真正删除
      delete() {
        this.$http
          .delete("basic","/productIntroductionTemplateGroups/idList",this.deleteIds).then(() => {
            this.deleteIds = [];
          });
      },
      deleteParams() {
        this.$http
          .delete("basic","/productIntroductionTemplateParams/idList",this.paramsIds).then(() => {
            this.paramsIds = [];
          });
      },
      handleSubmit() {
        if(this.deleteIds.length) {
          this.delete();
        }
        if(this.paramsIds.length) {
          this.deleteParams();
        }
        this.productIntroductionTemplate.productIntroductionTemplateGroupVOS = this.tableData;
        console.log(this.productIntroductionTemplate);
        this.handleSubmitSave();
        // console.log(this.tableData);
        // if(this.productIntroductionTemplate.pkid>0) {
        //   for (let item of this.tableData) {
        //     if(item.pkid) {
        //       this.workDetailUpData(item);
        //     }else {
        //       item.mastPKID = this.productIntroductionTemplate.pkid;
        //       this.workDetailSave(item);
        //     }
        //   }
        //   this.handleSubmitUpData();
        // }else {
        //   this.productIntroductionTemplate.workLineDetails = this.tableData;
        //   this.handleSubmitSave();
        // }
      },
      handleSubmitUpData() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .put("basic", "productIntroductionTemplates", this.productIntroductionTemplate)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
      workDetailUpData(item) {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .put("basic", "workLineDetails", item)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
      workDetailSave(item) {
        console.log(item);
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .post("basic", "workLineDetails", item)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
      handleSubmitSave() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .saveById("basic", "productIntroductionTemplates", this.productIntroductionTemplate,this.productIntroductionTemplate.pkid)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>


<style lang="scss" scoped>
    @import "../../../style/index";

    .editor {
        border: 1px solid $border-color;
    }
</style>
